<template>
  <div class="header">
    <div class="content" :style="{color: textColor}">
      <div>{{$t('layout.hello')}}</div>
      <div>
        <span class="lang" @click="changeLanguage('zh')">中文版</span>
        <span>|</span>
        <span class="lang" @click="changeLanguage('en')">English</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    textColor: {
      type: String,
      default: '#000'
    }
  },
  data () {
    return {}
  },
  computed: {
    localeLang: {
      get () { return this.$store.state.common.localeLang },
      set (val) { this.$store.commit('common/updateLocaleLang', val) }
    }
  },
  created () {
    
  },
  methods: {
    changeLanguage (lang) {
      this.$i18n.locale = lang;
      this.localeLang = lang
      localStorage.setItem('locale', lang);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/public.scss";
.header {
  width: 100%;
  height: 40px;
  position: absolute;
  top: 0;
  background: rgba($color: #000, $alpha: 0.2);
  z-index: 5;
  .content{
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    max-width: $main_content_width;
    margin: auto;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 40px;
    .lang{
      cursor: pointer;
    }
    .lang:hover{
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/header.vue